export const HERO_BG =
  "https://images.unsplash.com/photo-1708058887990-18f0dcb4e8a3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export const NICHE_IMAGES = {
  communication:
    "https://images.unsplash.com/photo-1622675363311-3e1904dc1885?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  batiment:
    "https://images.unsplash.com/photo-1587582423116-ec07293f0395?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  numerique:
    "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
};

export const PLANS = [
  {
    key: "essentiel",
    name: "Essentiel",
    monthly: 29,
    yearly: 278,
    tagline: "Pour démarrer sur votre région",
    features: [
      "Votre sélection de marchés chaque matin",
      "Basé sur le BOAMP officiel (gratuit, légal, à jour)",
      "Des fiches claires, lisibles en un coup d'œil",
      "Un secteur, jusqu'à 5 départements",
      "Rappels avant chaque date limite",
    ],
    lookup: "essentiel_monthly",
    lookupYear: "essentiel_yearly",
  },
  {
    key: "pro",
    name: "Pro",
    monthly: 59,
    yearly: 566,
    tagline: "La France entière, sans rien manquer",
    highlight: true,
    features: [
      "Tout Essentiel, partout en France",
      "Grands marchés européens avec leur montant (source TED)",
      "Le cahier des charges résumé pour vous",
      "La liste des pièces à préparer",
      "Vos mots-clés d'exclusion sur mesure",
      "Favoris et agenda des échéances",
    ],
    lookup: "pro_monthly",
    lookupYear: "pro_yearly",
  },
  {
    key: "premium",
    name: "Premium",
    monthly: 149,
    yearly: 1430,
    tagline: "Pour gagner, pas seulement candidater",
    features: [
      "Tout Pro inclus",
      "Analyse concurrentielle : qui a gagné, à quel montant",
      "Repère de prix médian (données DECP officielles)",
      "Marchés sous 90 k€ près de chez vous",
      "Votre mémoire technique prérédigé, prêt à personnaliser",
      "Accompagnement prioritaire",
    ],
    lookup: "premium_monthly",
    lookupYear: "premium_yearly",
  },
];

export const SEND_HOURS = [
  { v: 6, l: "06h00" }, { v: 7, l: "07h00" }, { v: 8, l: "08h00" },
  { v: 9, l: "09h00" }, { v: 12, l: "12h00" }, { v: 18, l: "18h00" },
];
